export enum CurrencyField {
    gbp = 'GBP',
    usd = 'USD',
    aud = 'AUD',
    cad = 'CAD',
    thb = 'THB',
}

export enum ProfileField {
    name = 'NAME',
    preferred_name = 'PRFNM',
    email = 'EMAIL',
    emailIsOptedIn = 'EMOPT',
    telephone = 'TEL',
    age_birthday = 'AGE',
    street_address = 'STADR',
    city = 'TOWN',
    state = 'STATE',
    zipcode = 'ZIP',
    country = 'CNTRY',
    gym_status = 'GYMST',
    membership_status = 'MEMST',
    punchpass_status = 'PUNST',
    guest_passes = 'GUEST',
    guest_passes_all_customers = 'GSTAL',
    capitan_status = 'CAPST',
    id_number = 'IDNUM',
    last_check_in = 'CHECK',
    check_in_count = 'CICNT',
    gender = 'GEND',
    pronouns = 'PRONS',
    barcode = 'BARCO',
    homeLocation = 'HLOC',
    referralCode = 'REFC',
    customCustomerField = 'CCF',
}

export enum PaymentProcessorType {
    stripe = 'STR',
    gravity = 'GRA',
    mxMerchant = 'MXM',
    mock = 'MOK',
}

export enum OrgPOSSoftware {
    none = '',
    lightspeed = 'VEN',
    square = 'SQU'
}

// Which purchases automatically send a customer an Allthenticate invite.
// Never treat SPECIFIC on its own as "this org uses Allthenticate": the mode
// is not reset when an integration is removed, so it must always be paired
// with has_allthenticate_integration before showing Allthenticate UI.
export enum AllthenticateInviteMode {
    all = 'ALL',
    specific = 'SPE'
}

export enum AccountingSoftwareType {
    none = '',
    xero = 'XER',
    quickbooksOnline = 'QBO'
}

export enum PaymentProcessorFeePolicy {
    doNotSubtract = 'DNS',
    subtractFromLineItem = 'SFL',
    subtractAsSeparateLineItem = 'SAS',
    sendToSeparateAccount = 'SSA'
}

export enum ReportingFirstDayOfWeek {
    sunday = 'SUN',
    monday = 'MON'
}

export enum MailchimpGroupCategoryType {
    checkboxes = 'checkboxes',
    dropdown = 'dropdown',
    radio = 'radio',
    hidden = 'hidden'
}

export enum CustomCustomerFieldType {
    checkboxes = 'CHK',
    dropdown = 'DRP',
    radio = 'RDO',
    singleLineText = 'SLT',
    multipleLineText = 'MLT'
}

export enum MailchimpSyncWindow {
    all = 'ALL',
    last12Months = 'L12'
}

export enum BarcodeFormat {
    code128 = 'COD',
    qrModel2 = 'QR2'
}

export enum TaxDisplayFormat {
    tax = 'TAX',
    vat = 'VAT',
    gst = 'GST'
}

export enum PrintPageSize {
  letter = 'LET',
  a4 = 'A4',
}

export enum CustomerProfileSidebarCard {
    emergencyContacts = 'emergency_contacts',
    medicalInfo = 'medical_info',
    proficiency = 'proficiency',
    notes = 'notes',
    documents = 'documents',
    challenges = 'challenges',
    linkedAccounts = 'linked_accounts',
    associations = 'associations',
    tags = 'tags',
    allthenticateStatus = 'allthenticate_status',
}

export const DEFAULT_SIDEBAR_ORDER: CustomerProfileSidebarCard[] = [
    CustomerProfileSidebarCard.emergencyContacts,
    CustomerProfileSidebarCard.medicalInfo,
    CustomerProfileSidebarCard.proficiency,
    CustomerProfileSidebarCard.notes,
    CustomerProfileSidebarCard.documents,
    CustomerProfileSidebarCard.challenges,
    CustomerProfileSidebarCard.linkedAccounts,
    CustomerProfileSidebarCard.associations,
    CustomerProfileSidebarCard.tags,
    CustomerProfileSidebarCard.allthenticateStatus,
];

export enum CustomerProfileActionButton {
    openSellScreen = 'open_sell_screen',
    addAlert = 'add_alert',
    editProfile = 'edit_profile',
    openClimberApp = 'open_climber_app',
    useRedemptionCode = 'use_redemption_code',
}

export const DEFAULT_ACTION_BUTTON_ORDER: CustomerProfileActionButton[] = [
    CustomerProfileActionButton.openSellScreen,
    CustomerProfileActionButton.addAlert,
    CustomerProfileActionButton.editProfile,
    CustomerProfileActionButton.openClimberApp,
    CustomerProfileActionButton.useRedemptionCode,
];
